"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = void 0;
function prepareAddressList(concatAddresses) {
  if (!concatAddresses) return "";
  var addresses = concatAddresses.split(/[,;]+/); //split by semicolon or comma

  addresses = addresses.map(function (address) {
    return address.trim();
  }); //remove any leading or trailing whitespace
  addresses = addresses.filter(function (address) {
    return address.length > 0;
  }); //remove any empty addresses

  if (addresses.length === 0)
    //no addresses
    return "";
  addresses.join(","); //now join them all with a comma
  return addresses;
}
var Email = exports.Email = {
  validateEmail: function validateEmail(email) {
    var regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return regex.test(String(email).toLowerCase());
  },
  //Sends email using the default mail client. concatAddresses is a string of email addresses separated by commas or semicolons
  sendEmail: function sendEmail(concatAddresses) {
    window.location = "mailto:" + prepareAddressList(concatAddresses);
  },
  //Sends BCC email using the default mail client. concatAddresses is a string of email addresses separated by commas or semicolons
  bccSendEmail: function bccSendEmail(concatAddresses) {
    window.location = "mailto:?bcc=" + prepareAddressList(concatAddresses);
  },
  sendEmailToMemberships: function sendEmailToMemberships(membershipsEmails) {
    var addresses = membershipsEmails.map(function (membershipsEmail) {
      return prepareAddressList(membershipsEmail);
    }); //get an array of all prepared addresses

    addresses.join(","); //now join them all with a comma

    window.location = "mailto:" + addresses;
  }
};